export enum DocumentSetEnum {
	REPAIRSHOP = 'repairshop',
	CUSTOMER = 'customer',
	DAMAGEASSESSOR = 'damageassessor',
	LAWYER = 'lawyer',
	MISC = 'misc',
}

export enum UserGroups {
	ADMIN = 'Administrator',
	EMPLOYEE = 'Mitarbeiter',
}

export enum AdType {
	//all = 'Alle',
	vehicle_registration_first = 'Erstzulassung',
	vehicle_manufacturer = 'Fahrzeughersteller',
	vehicle_model = 'Fahrzeugmodell',
	vehicle_hu = 'Hauptuntersuchung',
	vehicle_fuel = 'Kraftstoff',
	vehicle_exhaust_key = 'Abgasschlüssel',
	vehicle_kilometrage = 'Tachostand',
	vehicle_kw = 'KW',
	vehicle_displacement = 'Hubraum',
	shop_visit = 'Werkstattbesuch seit X Monaten',
	no_shop_visit = 'Kein Werkstattbesuch seit X Monaten'


	/*
        company = 'Firmeninhaber',
        city = 'Stadt - PLZ',

        vehicle_hu = 'Hauptuntersuchung fällig',
        vehicle_fuel = 'Kraftstoff',

        vehic_license_city = 'Nummernschild Stadt',

        /*
        vehicle_deactivated_by_customer = 'Fahrzeuge durch Kunde deaktiviert',
         */
}
